import React from 'react';
import { FormattedMessage } from 'react-intl';
import DataCenter from '@/modules/data/DataCenter';
import { chain, map } from 'lodash';
import { useInteractionState, useTranslation } from '@/hooks';
import { WorkHour } from '@/type';

export const HomeComponent = () => {
  const { language } = useTranslation();
  const { management, workHours } = useInteractionState();

  const workHourItems = map(workHours, (it: WorkHour) => (
    <p
      key={it.id}
      style={{
        textAlign: 'left',
        borderBottom: '1px solid',
        padding: '10px 0',
      }}
    >
      <span>
        <FormattedMessage id={'app.home.openHours.' + it.day_start} />
      </span>
      <span
        style={{
          display:
            it.day_start === 'sunday' || it.day_start === 'saturday'
              ? 'none'
              : '',
        }}
      >
        &nbsp;
        <FormattedMessage id="app.home.openHours.to" />
        &nbsp;
        <FormattedMessage id={'app.home.openHours.' + it.day_end} />
      </span>
      <span>
        {' '}
        : {it.start_time} - {it.end_time}
      </span>
    </p>
  ));

  const setAnnouncement = (language?: string) => {
    switch (language) {
      case DataCenter.SUPPORT_LANGUAGE.en.language:
        return management?.announcement_en;
      case DataCenter.SUPPORT_LANGUAGE.zh.language:
        return management?.announcement_zn;
      default:
        return management?.announcement_de;
    }
  };

  const announcement = setAnnouncement(language);
  const announcements = chain((announcement ?? '').split('\n'))
    .map((it: string[], key: number) => (
      <span key={key}>
        {it}
        <br />
      </span>
    ))
    .value();

  return (
    <section id="home">
      <div className="text-content container follow_container flex">
        <div className="row">
          <div className="col-md-4">
            <h2>
              <FormattedMessage id="app.home.announce" />
            </h2>
            <p
              style={{
                textAlign: 'left',
                borderBottom: '1px solid',
                padding: '10px 0',
              }}
            >
              {announcements}
            </p>
            <h4>
              <FormattedMessage id="app.home.mark" />
            </h4>
          </div>
          <div className="col-md-4">
            <img
              className="wrapper"
              src={'/images/background.png'}
              alt="background"
            />
          </div>
          <div className="col-md-4">
            <h2>
              <FormattedMessage id="app.home.openHours" />
            </h2>
            {workHourItems}
          </div>
        </div>
      </div>
    </section>
  );
};
